import React from 'react'

export default () =>
  <svg width='9' height='14' viewBox='0 0 9 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path fillRule='evenodd' clipRule='evenodd' d='M4.5 13.75C4.5 13.75 0 9.15979 0 5.65C0 2.41 1.87302 0.25 4.5 0.25C7.12698 0.25 9 2.95 9 5.65C9 9.1598 4.5 13.75 4.5 13.75ZM7 5.11C7 6.60117 5.88071 7.81 4.5 7.81C3.11929 7.81 2 6.60117 2 5.11C2 3.61883 3.11929 2.41 4.5 2.41C5.88071 2.41 7 3.61883 7 5.11Z' fill='black' />
  </svg>
